import { AntdButton, AntdSwitch } from "components"
import { AllowedTo } from "react-abac"
import { Permissions } from "config/constants"
import { useAppSelector, useFeatureFlags } from "hooks"
import { selectScheduleSaving } from "store/Schedules/schedules.slice"
import { FeatureFlagEnums } from "../../types/featureFlags.type"

interface Props {
	disableCreate: boolean
	disablePublish?: boolean
	disableAccept: boolean
	disableUpdate: boolean
	disableAllocate: boolean
	disableDelete: boolean
	disableAuto: boolean
	disableAudit: string
	disableIncident: boolean
	disableRotaLoad?: boolean
	disableRotaUnload?: boolean
	onCreateSchedules: () => void
	onPublishSchedules?: () => void
	onRecurringSchedules: () => void
	onCreateInActiveSchedule: () => void
	onUpdateSchedules: () => void
	onAllocateSchedule: () => void
	onAcceptSchedule: () => void
	onIncidentReport: () => void
	onAuditSchedule: () => void
	onDeleteSchedule: () => void
	showDeletedSchedules: (show: boolean) => void
	onRotaLoad?: () => void
	onRotaUnload?: () => void
}

const ScheduleCrudBar: React.FC<Props> = ({
	onCreateSchedules,
	onPublishSchedules,
	onRecurringSchedules,
	onCreateInActiveSchedule,
	onUpdateSchedules,
	onAcceptSchedule,
	onAllocateSchedule,
	onIncidentReport,
	onAuditSchedule,
	onDeleteSchedule,
	showDeletedSchedules,
	onRotaLoad = undefined,
	onRotaUnload = undefined,
	disableAudit,
	disableAuto = false,
	disableCreate = false,
	disablePublish = false,
	disableAccept = false,
	disableUpdate = false,
	disableAllocate = false,
	disableDelete = false,
	disableIncident = false,
	disableRotaLoad = false,
	disableRotaUnload = false,
}) => {
	const isScheduleSaving = useAppSelector(selectScheduleSaving())
	const { featureFlagEnabled } = useFeatureFlags()

	return (
		<div className="sticky top-0 flex w-1/2 gap-1 bg-white py-2">
			<div className="flex w-3/5 flex-wrap gap-1 2.5xl:w-full">
				<AllowedTo perform={Permissions.CREATE_AND_UPDATE_SCHEDULE}>
					<AntdButton size="middle" disabled={disableCreate} onClick={onCreateSchedules}>
						Create
					</AntdButton>
					<AntdButton size="middle" disabled={disablePublish} onClick={onPublishSchedules}>
						Publish
					</AntdButton>
					{onRotaLoad && featureFlagEnabled(FeatureFlagEnums.SCHEDULES_ROTA_PLANNER) && (
						<AntdButton size="middle" disabled={disableRotaLoad} onClick={onRotaLoad}>
							Load Rota
						</AntdButton>
					)}
					<AntdButton size="middle" disabled={disableCreate} onClick={onRecurringSchedules}>
						Recur
					</AntdButton>
					<AntdButton size="middle" disabled={disableAccept} onClick={onAcceptSchedule}>
						Accept
					</AntdButton>
					<AntdButton size="middle" disabled={disableUpdate} onClick={onUpdateSchedules}>
						Update
					</AntdButton>
					<AntdButton size="middle" disabled={disableAllocate} onClick={onAllocateSchedule}>
						Allocate
					</AntdButton>
					<AntdButton size="middle" disabled={disableIncident} onClick={onIncidentReport}>
						Incident
					</AntdButton>
					<AntdButton
						size="middle"
						disabled={disableAuto}
						onClick={onCreateInActiveSchedule}
						loading={isScheduleSaving}
					>
						Auto
					</AntdButton>
				</AllowedTo>

				{/* <FeatureFlagWrapper name={FeatureFlagEnums.SCHEDULES_AUDIT}> */}
				<AntdButton size="middle" disabled={!disableAudit} onClick={onAuditSchedule}>
					Audit
				</AntdButton>
				{/* </FeatureFlagWrapper> */}

				<AllowedTo perform={Permissions.CREATE_AND_UPDATE_SCHEDULE}>
					<AntdButton size="middle" disabled={disableDelete} onClick={onDeleteSchedule}>
						Delete
					</AntdButton>

					{onRotaUnload && featureFlagEnabled(FeatureFlagEnums.SCHEDULES_ROTA_PLANNER) && (
						<AntdButton size="middle" disabled={disableRotaUnload} onClick={onRotaUnload}>
							Unload Rota
						</AntdButton>
					)}
				</AllowedTo>

				{/* <FeatureFlagWrapper name={FeatureFlagEnums.SCHEDULES_SHOW_DELETED}> */}
				<div className="flex items-center justify-center">
					<AntdSwitch
						className="bg-[#00000035]"
						checkedChildren="Hide Deleted"
						unCheckedChildren="Show Deleted"
						onChange={e => showDeletedSchedules(e)}
					/>
				</div>
				{/* </FeatureFlagWrapper> */}
			</div>
		</div>
	)
}

export default ScheduleCrudBar
